export const FuelVolumeIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.5 7.5H47.5V52.5H12.5V7.5Z" stroke="url(#paint0_linear_368_3564)" strokeWidth="4"
                  strokeLinejoin="round"/>
            <path
                d="M7.5 7.5H52.5M7.5 52.5H52.5M7.5 30H12.5M47.5 30H52.5M25.8037 29.8612C27.5925 27.5112 28.9725 24.2625 29.7175 22.5C31.0225 24.2625 33.855 28.685 34.75 31.0363C35.8675 33.9738 33.0725 37.5 29.7175 37.5C26.3625 37.5 23.5675 32.8 25.8037 29.8612Z"
                stroke="url(#paint1_linear_368_3564)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <defs>
                <linearGradient id="paint0_linear_368_3564" x1="32.4138" y1="-17.6471" x2="99.0636" y2="63.2961"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
                <linearGradient id="paint1_linear_368_3564" x1="33.1034" y1="-17.6471" x2="94.7889" y2="78.6712"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};